import React, { useEffect, useState } from "react";
import TopSection from "../TopSection";
import CustomModel from "../model/CustomModel";
import "../../assets/styles/model.css";
import ConfirmPayment from "../card/ConfirmPayment";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmPaymentAction,
  getOneBookingAction,
} from "../../store/eventManagement/actions";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Spin } from "antd";
import { DefaultPlaceholder } from "../skeleton/Skeleton";

const format = "ddd, Do MMM YYYY";

const CheckoutForm = () => {
  const { auth, eventManagement } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { bookingId } = useParams();
  const [opneConfirmModel, setOpenConfirmModel] = useState(false);
  const [user, setUser] = useState(auth?.user || {});

  const bookingData = eventManagement?.selectedBooking;
  const totalTckets = bookingData?.tickets?.reduce(
    (curr, item) => curr + item?.quantity,
    0
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  useEffect(() => {
    if (auth?.user) {
      setUser(auth?.user);
    }
  }, [auth?.user]);

  useEffect(() => {
    if (bookingId) {
      getOneBookingAction(bookingId)(dispatch);
    }
  }, [bookingId, dispatch]);

  const handlePayment = async (e) => {
    e.preventDefault();
    const payload = {
      bookingId: bookingId,
      method: "Credit Card",
    };
    if (bookingId) {
      const res = await confirmPaymentAction(payload)(dispatch);
      if (res.type) {
        setOpenConfirmModel(true);
      }
    }
  };

  return (
    <>
      <TopSection title={"Order Confirmation"} />
      <div>
        <div className="w-full py-8 md:container">
          <div className="flex flex-col md:flex-row gap-8 px-4 ">
            <div className="flex-1 flex flex-col space-y-4">
              <div className="w-full bg-white p-6 rounded dark:bg-[#24262a]">
                <h4>Billing Information</h4>
                <hr />
                <form method="POST">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                    <div>
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        First Name*
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={user.firstName}
                        onChange={handleChange}
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        Last Name*
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={user.lastName}
                        onChange={handleChange}
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        Email*
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={user.email}
                        onChange={handleChange}
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        Country*
                      </label>
                      <input
                        type="text"
                        name="country"
                        value={user.country}
                        onChange={handleChange}
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        City*
                      </label>
                      <input
                        type="text"
                        name="city"
                        value={user.city}
                        onChange={handleChange}
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        Zip/Post Code*
                      </label>
                      <input
                        type="text"
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="w-full p-6  bg-white  rounded mt-4 md:mt-0 dark:bg-[#24262a]">
                <h4>{`Total Payable Amount : ${bookingData?.totalAmount?.toLocaleString()}$`}</h4>
                <hr />

                <form className="grid grid-cols-1 gap-4 mt-4" method="POST">
                  <div>
                    <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                      Card number*
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                      placeholder="Card number"
                    />
                  </div>
                  <div className="flex gap-4">
                    <div className="w-1/2">
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        Expiry date*
                      </label>
                      <input
                        type="text"
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                        placeholder="MM/YY"
                      />
                    </div>
                    <div className="w-1/2">
                      <label className="block text-base font-semibold pb-1 font-nunito dark:text-default">
                        CVV*
                      </label>
                      <input
                        type="text"
                        className="w-full border border-gray-300 p-2 rounded dark:bg-[#272b30] dark:border-none outline-none dark:text-default"
                        placeholder="CVV"
                      />
                    </div>
                  </div>
                  <button
                    className={`w-full bg-primary text-white py-2 rounded text-center ${
                      eventManagement?.isConfirmingPayment &&
                      "cursor-not-allowed"
                    }`}
                    onClick={handlePayment}
                  >
                    {eventManagement?.isConfirmingPayment ? (
                      <Spin />
                    ) : (
                      " Confirm & Pay"
                    )}
                  </button>
                </form>
              </div>
            </div>

            <div className="w-full md:w-1/3 bg-white p-6 rounded h-3/4 dark:bg-[#24262a]">
              <h4>Billing Information</h4>
              <hr />
              <div className="flex items-center mb-4 gap-x-4">
                <div className="pt-2">
                  {bookingData?.event?.imageUrl ? (
                    <img
                      src={bookingData?.event?.imageUrl}
                      alt={bookingData?.event._id}
                      className="w-full h-16 object-cover rounded-2xl"
                    />
                  ) : (
                    <DefaultPlaceholder />
                  )}
                </div>
                <div>
                  <p className="text-sm font-bold -mb-0.5 dark:text-white">
                    {bookingData?.event?.title}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-white">
                    {bookingData?.event && bookingData?.event.date
                      ? moment(bookingData?.event.date).format(format)
                      : ""}{" "}
                    .{bookingData?.event?.time_start}
                  </p>
                </div>
              </div>
              <div className="mb-4">
                {bookingData?.tickets?.map((d) => (
                  <div className="flex items-center justify-between border-b py-1 mb-4">
                    <span className="dark:text-white pb-2">
                      {d?.ticket?.type}
                    </span>
                    <span className="dark:text-white pb-2">{`${d?.ticket?.price?.toLocaleString()}$ x ${
                      d?.quantity
                    }`}</span>
                  </div>
                ))}
                <p className="flex justify-between text-sm">
                  <span>Total Ticket</span> <span>{totalTckets}</span>
                </p>
                <p className="flex justify-between text-sm">
                  <span>Sub Total</span>{" "}
                  <span>{`${bookingData?.totalAmount?.toLocaleString()}$`}</span>
                </p>
                <p className="flex justify-between">
                  <h4>Total</h4>{" "}
                  <h4>{`${bookingData?.totalAmount?.toLocaleString()}$`}</h4>
                </p>
              </div>
              <hr />
              <button
                className={`w-full bg-primary text-white py-2 rounded text-center mt-4 ${
                  eventManagement?.isConfirmingPayment && "cursor-not-allowed"
                }`}
                onClick={handlePayment}
              >
                {eventManagement?.isConfirmingPayment ? (
                  <Spin />
                ) : (
                  "Confirm & Pay"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <CustomModel
        openModal={opneConfirmModel}
        component={
          <ConfirmPayment onCancel={() => setOpenConfirmModel(false)} />
        }
        width={600}
      />
    </>
  );
};

export default CheckoutForm;
